import React, { useState } from 'react';
import { Alert, Button } from '@cimpress/react-components';

const AlertDemo = () => {
  const [alertDismissed, setAlertDismissed] = useState(true);

  const toggleDismissed = () => setAlertDismissed(!alertDismissed);

  return (
    <div>
      <Alert
        title="Title: Dismissible alert"
        message="There is a button on the right to 'hide' this alert"
        dismissible={true}
      />

      <Alert
        title="Title: Non-dismissible alert"
        message="The button on the right to 'hide' this alert is not shown"
        dismissible={false}
      />

      {['danger', 'info'].map(status => (
        <Alert key={status} status={status} message={`This is '${status}' alert`} dismissible={true} />
      ))}

      {['warning', 'success'].map(status => (
        <Alert key={status} status={status} message={`This is '${status}' alert`} dismissible={true} />
      ))}

      <Alert
        title="Title: Dismissible alert using an onDismiss callback"
        message="'Hiding' this alert will trigger a popup"
        dismissible={true}
        onDismiss={() => alert("The alert has been 'hidden'.")}
      />

      <Alert
        title="Props control"
        message="you can control me with a button"
        dismissible={true}
        dismissed={alertDismissed}
        onDismiss={toggleDismissed}
      />
      <Button onClick={toggleDismissed}>Toggle me</Button>
    </div>
  );
};

export default AlertDemo;
